import moment from "moment";
import 'moment/locale/es';

moment.locale(`${localStorage.getItem('__current_locale')?? 'en'}`);
let _moment = moment;

export default _moment
